export default function pickProps(obj, subset) {
  return subset.reduce(function (acc, key) {
    if (key in obj) {
      acc[key] = obj[key];
    }
    return acc;
  }, {});
}
